import React, { useMemo } from "react";
import {
  LinkTypeMap,
  List,
  ListItemButton,
  ListItemText,
  ListSubheader,
} from "@mui/material";
import { Theme } from "@mui/material/styles";
import { Link } from "../utils/link";

export type TableOfContentItem = {
  url: string;
  title: string;
  items?: TableOfContentItem[];
};

const styles = {
  listSubheader: {
    color: (theme: Theme) => theme.palette.text.primary,
    fontWeight: 600,
  },
};

function ListItemLink(props: LinkTypeMap<{}, "a">["props"]) {
  const { color, underline, ...rest } = props;
  return <ListItemButton component={Link} color="inherit" {...(rest as any)} />;
}

export function TableOfContents({ toc }: { toc: TableOfContentItem[] }) {
  const h2 = useMemo(
    () => toc.filter((x) => x.items !== undefined).flatMap((x) => x.items),
    [toc]
  );
  return (
    <List dense>
      <ListSubheader sx={styles.listSubheader} disableGutters>
        本文内容
      </ListSubheader>
      {h2.map((item, index) => (
        <ListItemLink key={index} href={item.url}>
          <ListItemText primary={item.title} />
        </ListItemLink>
      ))}
    </List>
  );
}
